export const constants = {
	selector: {
		root: '[data-mermaid]',
		graph: 'data-graph',
		src: 'data-src',
		config: 'data-config',
		ariaLabel: 'data-aria-label',
	},
}
